import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import _ from "lodash";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  codeGroupCreateRequestAction,
  codeGroupModifyRequestAction,
  deleteCodeGroupRequestAction,
  loadCodeGroupAction,
} from "../../redux/reducers/codeManagement";

const StyleScope = styled.div`
  .MuiTypography-displayBlock {
    font-size: 12px;
  }

  .table {
    max-width: 800px;

    th {
      width: 140px;
    }
  }

  .button-area {
    max-width: 800px;
  }

  .list-scroller {
    height: 200px;
    overflow-y: auto;
  }
`;

const useStyles = makeStyles((theme) => ({
  codeGroup: {
    width: "100%",
    maxWidth: 620,
    fontSize: "12px",
  },
}));

export default function CodeGroupForm(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { codeGroupList, selectGroupCode, selectGroupDetail } = useSelector(
    (state) => state.codeManagement
  );
  const [submitData, setSubmitData] = React.useState("");

  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      code: "",
      nm: "",
      description: "",
      useYn: "",
    },
  });
  const [open, setOpen] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  const searchCodeGroup = () => {
    return _.find(codeGroupList, (item) => {
      return item.code == selectGroupCode;
    });
  };

  useEffect(() => {
    dispatch(loadCodeGroupAction());
  }, []);

  useEffect(() => {
    if (selectGroupCode && selectGroupDetail) {
      setValue("code", selectGroupDetail.cd);
      setValue("nm", selectGroupDetail.nm);
      setValue("description", selectGroupDetail.desc);
      setValue("useYn", selectGroupDetail.useYn);
    } else {
      setValue("code", "");
      setValue("nm", "");
      setValue("description", "");
      setValue("useYn", "");
    }
  }, [selectGroupDetail, selectGroupCode]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnSubmit = (data) => {
    setSubmitData(data);

    setOpen(true);
  };

  const handleConfirm = () => {
    handleClose();

    if (selectGroupCode) {
      dispatch(codeGroupModifyRequestAction(submitData));
    } else {
      dispatch(codeGroupCreateRequestAction(submitData));

      reset();
    }
  };

  const [deleteConfirm, setDeleteConfirm] = React.useState(false);

  const handleConfirmDelete = () => {
    dispatch(deleteCodeGroupRequestAction(selectGroupCode));
    handleCloseDelete();
    setDeleteConfirm(true);
  };

  const handleSubmitClick = () => {
    clearErrors("code", { type: "validate" });
    clearErrors("code", { type: "successCode" });
  };

  const handleCodeGroupChange = ({ target }) => {
    if (target.value && typeof target.value == "string") {
      setValue("code", target.value.toUpperCase());
    }
  };

  const handleDuplicateCheck = () => {
    let notDuplicate = true;

    _.forEach(codeGroupList, (item) => {
      if (item.cd == getValues("code")) {
        notDuplicate = false;
      }
    });

    return notDuplicate;
  };

  const handleDuplicateCheckClick = () => {
    let chk = handleDuplicateCheck();

    clearErrors("code", { type: "validate" });
    clearErrors("code", { type: "successCode" });

    if (chk == false) {
      setError("code", {
        type: "validate",
      });
    } else {
      setError("code", {
        type: "successCode",
      });
    }
  };

  const handleDelete = () => {
    setOpenDelete(true);
  };

  const handleCancle = () => {
    // reset();
    setValue("code", selectGroupDetail.cd);
    setValue("nm", selectGroupDetail.nm);
    setValue("description", selectGroupDetail.desc);
    setValue("useYn", selectGroupDetail.useYn);
  };

  return (
    <>
      <div className="mt-5 mb-2">
        {/* <h6 className="d-inline me-2"></h6> */}
        <Box mt={2}>
          <h3>코드그룹 정보</h3>
        </Box>
        <Box color="error.main">
          ( <em className="text-danger">*</em> 는 필수입력 항목입니다.)
        </Box>
      </div>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <table className="table">
          <tbody>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="code-group">
                  코드그룹
                </InputLabel>
              </th>
              <td>
                {selectGroupCode ? (
                  <Box mt={1}>
                    <InputLabel htmlFor="pgSz">{selectGroupCode}</InputLabel>
                  </Box>
                ) : (
                  <Grid container>
                    <Grid item xs={9}>
                      <TextField
                        inputProps={{
                          maxLength: 3,
                        }}
                        placeholder="AAA"
                        fullWidth
                        maxLength="3"
                        {...register("code", {
                          required: true,
                          minLength: 3,
                          validate: handleDuplicateCheck,
                        })}
                        onInput={handleCodeGroupChange}
                      />

                      {errors.code?.type === "validate" && (
                        <FormHelperText>
                          이미 사용중인 코드입니다.
                        </FormHelperText>
                      )}

                      {errors.code?.type === "successCode" && (
                        <FormHelperText className="text-success">
                          사용 가능한 코드입니다.
                        </FormHelperText>
                      )}

                      {errors.code?.type === "required" && (
                        <FormHelperText>
                          코드그룹을 입력해 주세요.
                        </FormHelperText>
                      )}

                      {errors.code?.type === "minLength" && (
                        <FormHelperText>3자 이상 입력해 주세요.</FormHelperText>
                      )}

                      {errors.duplicateCheck?.type === "manual" && (
                        <FormHelperText>
                          {errors.duplicateCheck?.message}
                        </FormHelperText>
                      )}

                      {errors.duplicate?.type === "manual" && (
                        <FormHelperText>
                          {errors.duplicate?.message}
                        </FormHelperText>
                      )}
                    </Grid>
                    <Grid item xs={3}>
                      <Box ml={1}>
                        <Button
                          variant="contained"
                          className="ms-2"
                          size="small"
                          color="primary"
                          onClick={handleDuplicateCheckClick}
                        >
                          중복 확인
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="code-group-name">
                  코드그룹명
                </InputLabel>
              </th>
              <td>
                <TextField
                  placeholder="텍스트를 입력해주세요."
                  fullWidth
                  {...register("nm", {
                    required: true,
                  })}
                />

                {errors.nm?.type === "required" && (
                  <FormHelperText>텍스트를 입력해주세요.</FormHelperText>
                )}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel htmlFor="code-group">설명</InputLabel>
              </th>
              <td>
                <TextField
                  fullWidth
                  placeholder="텍스트를 입력해주세요."
                  {...register("description", { required: false })}
                />
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="code-group">
                  사용여부
                </InputLabel>
              </th>
              <td>
                <Controller
                  rules={{
                    required: true,
                  }}
                  defaultValue=""
                  name="useYn"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <RadioGroup
                      aria-label="disp"
                      name="useYn"
                      row
                      value={value}
                      onChange={onChange}
                    >
                      <FormControlLabel
                        value="Y"
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            icon={<span className="radio-icon" />}
                            checkedIcon={
                              <span className="radio-icon-checked" />
                            }
                          />
                        }
                        label="사용"
                      />
                      <FormControlLabel
                        value="N"
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            icon={<span className="radio-icon" />}
                            checkedIcon={
                              <span className="radio-icon-checked" />
                            }
                          />
                        }
                        label="미사용"
                      />
                    </RadioGroup>
                  )}
                />

                {errors.useYn?.type === "required" && (
                  <FormHelperText>사용여부를 선택해 주세요.</FormHelperText>
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <Grid container className=" button-area">
          <Grid item xs={6}>
            {selectGroupCode && (
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={handleDelete}
              >
                삭제
              </Button>
            )}
          </Grid>
          <Grid item xs={6} className="text-end">
            <Box display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                size="small"
                color="secondary"
                // onClick={props.handleClose}
                onClick={handleCancle}
              >
                취소
              </Button>
              <Button
                variant="contained"
                size="small"
                color="primary"
                type="submit"
                onClick={handleSubmitClick}
              >
                {selectGroupCode ? <span>수정</span> : <span>등록</span>}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
      <Dialog
        open={open}
        onClose={handleClose}
        className="alert-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">알림</DialogTitle>
        <DialogContent dividers>
          {selectGroupCode ? <>수정하시겠습니까?</> : <>등록하시겠습니까?</>}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="secondary">
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        className="alert-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="customized-dialog-title">알림</DialogTitle>
        <DialogContent dividers>
          삭제 시 연결된 데이터에 문제가 발생할 수 있습니다.
          <br /> 정말 삭제하시겠습니까?
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleCloseDelete}
            color="secondary"
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDelete}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteConfirm}
        className="alert-dialog"
        onClose={() => {
          setDeleteConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="customized-dialog-title">알림</DialogTitle>
        <DialogContent dividers>삭제되었습니다.</DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setDeleteConfirm(false);
            }}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
